import React, { useEffect, useState, useMemo, useCallback } from 'react';
import DeleteIcon from '@material-ui/icons/Delete';
import { Assignment } from '@material-ui/icons';
import ManageAccountGrid from '../../../managementAccount/manageAccountGrid';
import { EditButton } from '../../../../Core/FormInput/inputfields';
import BreadCrumbs from '../../../../Core/Controls/Breadcrumb';
import DialogComp from '../../../../Core/Controls/Dialog/DialogComp';
import MappingSubModal from './mappingSubModal';
import { IconButton, Tooltip } from '@material-ui/core';
import { maMappingValue_Delete } from '../../../../Core/Service/MappingService';
import ConfirmationModal from '../../../../Core/Controls/Dialog/ConfirmationModal';

const basecolumns = [
    { field: 'action', title: 'Action', width: '7%' },
    { field: 'mappingValue', title: 'Mapping Value' },
    { field: 'description', title: 'Description' },
    { field: 'category', title: 'Category' }
];

function MappingListScreen(props) {
    const [state, setState] = useState({
        open: false,
        showWarning: false,
        selectedRowData: null,
        tabsToggle: false,
        isReload: null
    });

    const renderEdit = (ev, row) => {
        return (
            <div
                style={{
                    textAlign: 'center',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '4px', 
                    minWidth: 100 
                }}
            >
                <EditButton
                    toolTipTitle="Edit"
                    style={{ marginLeft: -20 }}
                    onClick={() => {
                        setState((st) => ({
                            ...st,
                            tabsToggle: true,
                            selectedRowData: row
                        }));
                    }}
                />
                <Tooltip title="Delete Mapping Value" aria-label="delete">
                    <IconButton size="small" onClick={() => handleDeleteClick(row)}>
                        <DeleteIcon fontSize="small" color="secondary" />
                    </IconButton>
                </Tooltip>
            </div>
        );
    };

    const columns = useMemo(() => {
        const tempCols = [...basecolumns];
        let actionCol = tempCols.find((e) => e.field === 'action');
        if (actionCol) {
            actionCol.renderer = renderEdit;
        }
        return tempCols;
    }, []);

    const handleDeleteClick = useCallback((row) => {
        setState((st) => ({
            ...st,
            showWarning: true,
            selectedRowData: row
        }));
    }, []);

    const removeMappingValue = () => {
        maMappingValue_Delete(state.selectedRowData.mappingValueID)
            .then(() => {
                setState((st) => ({
                    ...st,
                    showWarning: false,
                    isReload: new Date()
                }));
            })
            .catch((error) => {
                console.error('Delete failed:', error);
            });
    };

    const hideConfirmationModal = () => {
        setState((st) => ({
            ...st,
            showWarning: false
        }));
    };

    const addBtnClicked = () => {
        setState((st) => ({
            ...st,
            tabsToggle: true,
            selectedRowData: {}
        }));
    };

    const closeDialog = (isReload) => {
        let newSt = { tabsToggle: false };
        if (isReload) newSt.isReload = new Date();
        setState((st) => ({ ...st, ...newSt }));
    };

    return (
        <div className="screen">
            <ManageAccountGrid
                dataConverter={(res) => ({
                    records: res.data.list,
                    total: res.data.total
                })}
                columns={columns}
                getUrl={`MappingValues?positionID=${props.positionID}`}
                btnTitle="Add Sub Mapping Value"
                onBtnClick={addBtnClicked}
                isReload={state.isReload}
            />

            {state.tabsToggle && (
                <DialogComp
                    title={state.selectedRowData?.mappingValueID ? 'Update Mapping Data' : 'Add Mapping Data'}
                    onClose={() => closeDialog(false)}
                    maxWidth="sm"
                    fullWidth
                >
                    <MappingSubModal
                        onClose={closeDialog}
                        selectedRowData={state.selectedRowData}
                        maMappingPositionsID={props.positionID}
                        positionLength={props.positionLength}
                    />
                </DialogComp>
            )}

            {state.showWarning && (
                <DialogComp title="Warning" onClose={hideConfirmationModal} maxWidth="sm" fullWidth>
                    <ConfirmationModal
                        message={`Are you sure you want to remove - ${state.selectedRowData?.mappingValue}`}
                        handleSubmit={removeMappingValue}
                        handleCancel={hideConfirmationModal}
                    />
                </DialogComp>
            )}
        </div>
    );
}

export default MappingListScreen;
